import {
  ADVANCE_LOSS_OF_PROFIT,
  BAJAJ,
  BHARTI_AXA,
  BOILER_PLANT_AND_MACHINERY,
  CONTRACTORS_PLANT_AND_MACHINERY,
  CONTRACTOR_ALL_RISK,
  ELECTRONIC_EQUIPMENT,
  ERECTION_ALL_RISK,
  formType,
  FUTURE_GENERALI,
  HDFC_ERGO,
  ICICI_LOMBARD,
  IFFCO_TOKIO,
  INDUSTRIAL_ALL_RISK,
  LIBERTY,
  MACHINERY_BREAKDOWN,
  NEW_INDIA,
  ORIENTAL_INSURANCE,
  RELIANCE,
  ResourceProductType,
  SBI,
  SHRIRAM,
  UNITED_INDIA,
  UNIVERSAL_SOMPO,
} from './constants';

export const Engineering: ResourceProductType = {
  [BAJAJ]: {
    [BOILER_PLANT_AND_MACHINERY]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Engineering/Bajaj%20Allianz/Boiler%20Plant%20%26%20Manchinery/boiler%20%26%20pressure%20plant%20-%20claim-form.pdf',
        formType: formType.ClaimForm,
      },
    ],
    [CONTRACTOR_ALL_RISK]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Engineering/Bajaj%20Allianz/Contractor%20All%20Risk/bajaj-allianz-contractor%20all%20risk-insurance-claim-form.pdf',
        formType: formType.ClaimForm,
      },
    ],
    [CONTRACTORS_PLANT_AND_MACHINERY]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Engineering/Bajaj%20Allianz/Contractors%20plant%20and%20Machinery/bajaj-allianz-contractor%20plant%20and%20machinery-insurance-claim-form.pdf',
        formType: formType.ClaimForm,
      },
    ],
    [ELECTRONIC_EQUIPMENT]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Engineering/Bajaj%20Allianz/Electronic%20Equipment/bajaj-allianz-electronic%20equipment-insurance-claim-form.pdf',
        formType: formType.ClaimForm,
      },
    ],
    [ERECTION_ALL_RISK]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Engineering/Bajaj%20Allianz/Erection%20All%20Risk/bajaj-allianz-erection%20all%20risk-insurance-claim-form.pdf',
        formType: formType.ClaimForm,
      },
    ],
    [INDUSTRIAL_ALL_RISK]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Engineering/Bajaj%20Allianz/Industrial%20All%20risk/bajaj-allianz-industrial%20all%20risk-insurance-claim-form.pdf',
        formType: formType.ClaimForm,
      },
    ],
    [MACHINERY_BREAKDOWN]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Engineering/Bajaj%20Allianz/Machinery%20Breakdown/bajaj-allianz-machinery%20breakdown-insurance-claim-form.pdf',
        formType: formType.ClaimForm,
      },
    ],
  },
  [BHARTI_AXA]: {
    [ADVANCE_LOSS_OF_PROFIT]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Engineering/Bharti%20Axa%20(Now%20ICICI%20Lombard)/ALOP/advance%20loss%20of%20profit%20-%20proposalform.pdf',
        formType: formType.ProposalForm,
      },
    ],
    [BOILER_PLANT_AND_MACHINERY]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Engineering/Bharti%20Axa%20(Now%20ICICI%20Lombard)/Boiler%20Plant%20%26%20Machinery/boiler-insurance-claim-form.pdf',
        formType: formType.ClaimForm,
      },
    ],
    [CONTRACTOR_ALL_RISK]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Engineering/Bharti%20Axa%20(Now%20ICICI%20Lombard)/Contractor%20All%20Risk/bharti-axa-contractor-all-risk-insurance-claim-form.pdf',
        formType: formType.ClaimForm,
      },
    ],
    [CONTRACTORS_PLANT_AND_MACHINERY]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Engineering/Bharti%20Axa%20(Now%20ICICI%20Lombard)/Contractors%20plant%20and%20Machinery/bharti-axa-contractor-plant-machinery-insurance-claim-form.pdf',
        formType: formType.ClaimForm,
      },
    ],
    [ELECTRONIC_EQUIPMENT]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Engineering/Bharti%20Axa%20(Now%20ICICI%20Lombard)/Electronic%20Equipment/bharti-axa-electronic-equipment-insurance-claim-form.pdf',
        formType: formType.ClaimForm,
      },
    ],
    [ERECTION_ALL_RISK]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Engineering/Bharti%20Axa%20(Now%20ICICI%20Lombard)/Erection%20All%20Risk/bharti-axa-erection-all-risk-insurance-claim-form.pdf',
        formType: formType.ClaimForm,
      },
    ],
    [MACHINERY_BREAKDOWN]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Engineering/Bharti%20Axa%20(Now%20ICICI%20Lombard)/Machinery%20Breakdown/bharti-axa-machinery-breakdown-insurance-claim-form.pdf',
        formType: formType.ClaimForm,
      },
    ],
  },
  [FUTURE_GENERALI]: {
    [BOILER_PLANT_AND_MACHINERY]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Engineering/Future%20Generali/Boiler%20Plant%20%26%20Machinery/boiler-%26-pressure-plant-insurance-claim-form.pdf',
        formType: formType.ClaimForm,
      },
    ],
    [CONTRACTOR_ALL_RISK]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Engineering/Future%20Generali/Contractor%20All%20Risk/future-generali-contractors-all-risk-insurance-claim-form.pdf',
        formType: formType.ClaimForm,
      },
    ],
    [ELECTRONIC_EQUIPMENT]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Engineering/Future%20Generali/Electronics%20Equipment/future-generali-electronice-equipment-insurance-claim-form.pdf',
        formType: formType.ClaimForm,
      },
    ],
    [ERECTION_ALL_RISK]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Engineering/Future%20Generali/Erection%20All%20Risk/future-generali-erection-all-risk-insurance-claim-form.pdf',
        formType: formType.ClaimForm,
      },
    ],
    [MACHINERY_BREAKDOWN]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Engineering/Future%20Generali/Machinery%20Breakdown/future-generali-machinery-breakdown-insurance-claim-form.pdf',
        formType: formType.ClaimForm,
      },
    ],
  },
  [HDFC_ERGO]: {
    [CONTRACTOR_ALL_RISK]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Engineering/HDFC%20Ergo/Contractor%20All%20Risk/hdfc-ergo-contractor-all-risk-insurance-claim-form.pdf',
        formType: formType.ClaimForm,
      },
    ],
    [ELECTRONIC_EQUIPMENT]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Engineering/HDFC%20Ergo/Electronics%20Equipment/hdfc-ergo-electronic-equipment-claim-form.pdf',
        formType: formType.ClaimForm,
      },
    ],
    [ERECTION_ALL_RISK]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Engineering/HDFC%20Ergo/Erection%20All%20Risk/hdfc-ergo-erection-all-risk-insurance-claim-form.pdf',
        formType: formType.ClaimForm,
      },
    ],
    [MACHINERY_BREAKDOWN]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Engineering/HDFC%20Ergo/Machinery%20Breakdown/hdfc-ergo-machinery-breakdown-insurance-claim-form.pdf',
        formType: formType.ClaimForm,
      },
    ],
  },
  [ICICI_LOMBARD]: {
    [CONTRACTORS_PLANT_AND_MACHINERY]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Engineering/ICICI%20Lombard/Contractors%20plant%20and%20Machinery/icici%20lombard-contractors-plant-machinery.pdf',
        formType: formType.ClaimForm,
      },
    ],
    [ELECTRONIC_EQUIPMENT]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Engineering/ICICI%20Lombard/Electronics%20Equipment/icici%20lombard-electronic_equipment_insurance.pdf',
        formType: formType.ClaimForm,
      },
    ],
    [ERECTION_ALL_RISK]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Engineering/ICICI%20Lombard/Erection%20All%20Risk/icici%20lombard-erection-all-risk.pdf',
        formType: formType.ClaimForm,
      },
    ],
    [INDUSTRIAL_ALL_RISK]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Engineering/ICICI%20Lombard/Industrial%20All%20Risk/Icici%20lombard%20Industrial%20All%20Risk%20-%20Claim%20form.pdf',
        formType: formType.ClaimForm,
      },
    ],
    [MACHINERY_BREAKDOWN]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Engineering/ICICI%20Lombard/Machinery%20Breakdown/icici%20lombard-machinery-breakdown.pdf',
        formType: formType.ClaimForm,
      },
    ],
  },
  [IFFCO_TOKIO]: {
    [ELECTRONIC_EQUIPMENT]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Engineering/Iffco%20Tokio/Electronics%20Equipment/iffco-tokio-electronic-equipment-insurance-claim-form.pdf',
        formType: formType.ClaimForm,
      },
    ],
    [MACHINERY_BREAKDOWN]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Engineering/Iffco%20Tokio/Machinery%20Breakdown/iffco-tokio-machinery-breakdown-insurance-claim-form.pdf',
        formType: formType.ClaimForm,
      },
    ],
  },
  [LIBERTY]: {
    [ADVANCE_LOSS_OF_PROFIT]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Engineering/Liberty%20Insurance/ALOP/ADVANCE%20LOSS%20OF%20PROFIT%20INSURANCE%20-%20CLAIM%20FORM.pdf',
        formType: formType.ClaimForm,
      },
    ],
    [CONTRACTOR_ALL_RISK]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Engineering/Liberty%20Insurance/Contractor%20All%20Risk/liberty-videocon-contractor-all-risk-insurance-claim-form.pdf',
        formType: formType.ClaimForm,
      },
    ],
    [CONTRACTORS_PLANT_AND_MACHINERY]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Engineering/Liberty%20Insurance/Contractors%20plant%20and%20Machinery/liberty-videocon-contractor-plant-and-machinery-insurance-claim-form.pdf',
        formType: formType.ClaimForm,
      },
    ],
    [ELECTRONIC_EQUIPMENT]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Engineering/Liberty%20Insurance/Electronics%20Equipment/liberty-videocon-electronic-equipment-insurance-claim-form.pdf',
        formType: formType.ClaimForm,
      },
    ],
    [ERECTION_ALL_RISK]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Engineering/Liberty%20Insurance/Erection%20All%20Risk/liberty-videocon-erection-all-risk-insurance-claim-form.pdf',
        formType: formType.ClaimForm,
      },
    ],
  },
  [NEW_INDIA]: {
    [CONTRACTOR_ALL_RISK]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Engineering/New%20India%20Assurance/Contractor%20All%20Risk/new-india-contractors-all-risk-insurance-claim-form.pdf',
        formType: formType.ClaimForm,
      },
    ],
    [CONTRACTORS_PLANT_AND_MACHINERY]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Engineering/New%20India%20Assurance/Contractors%20plant%20and%20Machinery/new-india-contractor-plant-and-machinery-insurance-claim-form.pdf',
        formType: formType.ClaimForm,
      },
    ],
    [ELECTRONIC_EQUIPMENT]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Engineering/New%20India%20Assurance/Electronics%20Equipment/new-india-electronic-equipment-insurance-claim-form.pdf',
        formType: formType.ClaimForm,
      },
    ],
    [ERECTION_ALL_RISK]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Engineering/New%20India%20Assurance/Erection%20All%20Risk/new-india-erection-insurance-claim-form.pdf',
        formType: formType.ClaimForm,
      },
    ],
    [MACHINERY_BREAKDOWN]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Engineering/New%20India%20Assurance/Machinery%20Breakdown/new-india-machinery-insurance-claim-form.pdf',
        formType: formType.ClaimForm,
      },
    ],
  },
  [ORIENTAL_INSURANCE]: {
    [ELECTRONIC_EQUIPMENT]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Engineering/Oriental%20Insurrance/Electronics%20Equipment/Oriental%20Insurance%20-%20Electronic%20Equipment%20Claim%20Form.pdf',
        formType: formType.ClaimForm,
      },
    ],
    [INDUSTRIAL_ALL_RISK]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Engineering/Oriental%20Insurrance/Industrial%20All%20Risk/Oriental-All-RiskClaimForm.pdf',
        formType: formType.ClaimForm,
      },
    ],
  },
  [RELIANCE]: {
    [CONTRACTOR_ALL_RISK]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Engineering/Reliance%20General/Contractor%20All%20Risk/Relience%20General%20CONTRACTORS%20ALL%20RISKS%20-%20CLAIM%20FORM.pdf',
        formType: formType.ClaimForm,
      },
    ],
    [ELECTRONIC_EQUIPMENT]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Engineering/Reliance%20General/Electronics%20Equipment/reliance-electronic-equipment-insurance-claim-form.pdf',
        formType: formType.ClaimForm,
      },
    ],
    [ERECTION_ALL_RISK]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Engineering/Reliance%20General/Erection%20All%20Risk/Relience%20ERECTION%20ALL%20RISK%20-%20CLAIM%20FORM.pdf',
        formType: formType.ClaimForm,
      },
    ],
  },
  [SBI]: {
    [ADVANCE_LOSS_OF_PROFIT]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Engineering/SBI%20General/ALOP/sbi%20general-alop%20claim%20form.pdf',
        formType: formType.ClaimForm,
      },
    ],
    [BOILER_PLANT_AND_MACHINERY]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Engineering/SBI%20General/Boiler%20Plant%20%26%20Machinery/sbi-insurance-boiler-and-pressure-plant-insurance-claim-form.pdf',
        formType: formType.ClaimForm,
      },
    ],
    [ERECTION_ALL_RISK]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Engineering/SBI%20General/Erection%20All%20Risk/sbi-insurance-erection-all-risk-insurance-claim-form.pdf',
        formType: formType.ClaimForm,
      },
    ],
    [INDUSTRIAL_ALL_RISK]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Engineering/SBI%20General/Industrial%20All%20Risk/sbi-insurance-industrial%20all%20risk-insurance-claim-form.pdf',
        formType: formType.ClaimForm,
      },
    ],
    [MACHINERY_BREAKDOWN]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Engineering/SBI%20General/Machinery%20Breakdown/sbi-insurance-machinery-breakdown-insurance-claim-form.pdf',
        formType: formType.ClaimForm,
      },
    ],
  },
  [SHRIRAM]: {
    [BOILER_PLANT_AND_MACHINERY]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Engineering/Shriram%20Insurance/Boiler%20Plant%20%26%20Machinery/shriram-boiler-and-pressure-plant-claim-form.pdf',
        formType: formType.ClaimForm,
      },
    ],
    [CONTRACTORS_PLANT_AND_MACHINERY]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Engineering/Shriram%20Insurance/Contractors%20plant%20and%20Machinery/shriram-contractor-plant-and-machinery-insurance-claim-form.pdf',
        formType: formType.ClaimForm,
      },
    ],
    [MACHINERY_BREAKDOWN]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Engineering/Shriram%20Insurance/Machinery%20Breakdown/shriram-machinery-breakdown-claim-form.pdf',
        formType: formType.ClaimForm,
      },
    ],
  },
  [UNITED_INDIA]: {
    [MACHINERY_BREAKDOWN]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Engineering/United%20India/Machinery%20Breakdown/united-india-machinery-breakdown-and-loss-of-profit-claim-form.pdf',
        formType: formType.ClaimForm,
      },
    ],
  },
  [UNIVERSAL_SOMPO]: {
    [BOILER_PLANT_AND_MACHINERY]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Engineering/Universal%20Sompo/Boiler%20Plant%20%26%20Machinery/universal-sompo-boiler-and-pressure-plant-insurance-claim-form.pdf',
        formType: formType.ClaimForm,
      },
    ],
    [CONTRACTOR_ALL_RISK]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Engineering/Universal%20Sompo/Contractor%20All%20Risk/universal-sompo-contractor-all-risk-insurance-claim-form.pdf',
        formType: formType.ClaimForm,
      },
    ],
    [CONTRACTORS_PLANT_AND_MACHINERY]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Engineering/Universal%20Sompo/Contractors%20plant%20and%20Machinery/universal-sompo-contractor-plant-and-machinery-insurance-claim-form.pdf',
        formType: formType.ClaimForm,
      },
    ],
    [ERECTION_ALL_RISK]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Engineering/Universal%20Sompo/Erection%20All%20Risk/universal-sompo-erection-all-risk-insurance-claim-form.pdf',
        formType: formType.ClaimForm,
      },
    ],
  },
};
